/**
 * Created by Mark on 05/04/2017.
 */


import React from "react"; 
import PieGraph from './graphs/PieGraph.js';
import {Col , Row} from 'react-bootstrap';
import Translation from '../store/internationalization-store.js';

export default class HomeworkWidget extends React.Component {


    constructor(props){
        super();

        this.state = {
            totalComplete : props.totalComplete || 0,
            totalIncomplete : props.totalIncomplete || 0,
            totalInProgress: props.totalInProgress || 0,
            totalOverdue : props.totalOverdue || 0,
            studentTotal : props.studentTotal || 0,
        }
    }

    componentWillReceiveProps(props){

        this.setState({
            totalComplete : props.totalComplete || 0,
            totalIncomplete : props.totalIncomplete || 0,
            totalInProgress: props.totalInProgress || 0,
            totalOverdue : props.totalOverdue || 0,
            studentTotal : props.studentTotal || 0,
        });
    }


    render(){
        return (
            <div className="homework-widget">
                <Row className="pie-grid clearfix text-center">
                    <Col className="col-xs-4 col-sm-6 col-md-4 pg-item" style={{padding:0}} md={4}>
                        <PieGraph data={[{name: '' , value: Number(this.state.totalComplete) , fill:"#ffffff" }, {name: '' , value: Number(this.state.studentTotal) -  Number(this.state.totalComplete) , fill:"#cccccc"}]} index={0} id="HomeworkCompleted"  height={120} />
                        <div className="pgi-title">
                            <b> {Number(this.state.totalComplete)} {Translation.get('772', 'Devoirs terminés')}</b>
                        </div>
                    </Col>
                    <Col className="col-xs-4 col-sm-6 col-md-4 pg-item"  style={{padding:0}} md={4} >
                        <PieGraph data={[{name: '' , value: Number(this.state.totalInProgress) , fill:"#ffffff" }, {name: '' , value: Number(this.state.studentTotal) -  Number(this.state.totalInProgress) , fill:"#cccccc"}]} index={0} id="HomeworkNotCompleted" height={120}/>
                        <div className="pgi-title">
                            <b>{Number(this.state.totalInProgress)} {Translation.get('12166', 'En cours')}</b>
                        </div>
                    </Col>
                    <Col  className="col-xs-4 col-sm-6 col-md-4 pg-item"  style={{padding:0}} md={4}>
                        <PieGraph data={[{name: '' , value: Number(this.state.totalOverdue) , fill:"#ffffff" }, {name: '' , value: Number(this.state.studentTotal) -  Number(this.state.totalOverdue) , fill:"#cccccc"}]} index={0} id="HomeworkCompleted"  height={120} />
                        <div className="pgi-title">
                            <b>{Number(this.state.totalOverdue)} {Translation.get('12324', 'En cours')}</b>
                        </div>
                    </Col>
                </Row>
                <br/>
            </div>
        );
    }
}